module.exports = __webpack_public_path__ + "img/6.83a0a110.jpg";